import { CSSProperties } from 'react';

import { makeStyles, useTheme } from '@material-ui/core/styles';

export type VideoPlayerStyleProps = {
	objectFit: CSSProperties['objectFit'];
};

export const Theme = useTheme;
export const useStyles = makeStyles(theme => ({
	videoPlayerContainer: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		cursor: 'pointer',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		height: '100%'
	},
	videoPointerDisabled: {
		cursor: 'default'
	},
	videoCover: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0
	},
	coverDisabled: {
		pointerEvents: 'none'
	},
	videoThumbnailContainer: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundSize: 'cover',
		opacity: 1,
		transition: 'opacity 250ms'
	},
	videoThumbnailHidden: {
		opacity: 0
	},
	videoThumbnail: {
		width: '100%',
		height: '100%',
		objectFit: 'cover',
		objectPosition: '50% 50%'
	},
	videoPlayer: {
		maxWidth: '100%',
		maxHeight: '100%',
		height: (props: VideoPlayerStyleProps) => (props.objectFit === 'cover' ? '100%' : ''),
		width: (props: VideoPlayerStyleProps) => (props.objectFit === 'cover' ? '100%' : ''),
		objectFit: (props: VideoPlayerStyleProps) => props.objectFit
	},
	videoPlayerFullScreen: {
		objectFit: 'contain !important' as any
	},
	videoPreviewContainer: {
		position: 'relative',
		height: '100%',
		width: '100%'
	},
	videoPlayerHidden: {
		display: 'none'
	},
	videoItemButtonContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		position: 'absolute',
		background: 'rgb(0 0 0 / 38%)',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		pointerEvents: 'none'
	},
	videoPlayButton: {
		padding: 0
	},
	videoItemIcon: {
		color: '#FFF'
	},
	videoItem: {
		width: '100%'
	}
}));
